import * as React from "react";
import {
  IMAGE_SRC,
  PlaylistSong,
  soundEffect,
} from "../../../../common/constants";
import { Slider } from "@mui/material";
import { Icons } from "../../../Icons/Icons";
import styled from "styled-components";
import { Rnd } from "react-rnd";
import { useDispatch, useSelector } from "react-redux";
import {
  getPlaylist,
  setCurrentIndexSong,
  setPlay,
  setplaylistSpotify,
  setValueVolume,
} from "../../../../store/features/audioSlice";
import { RootState } from "../../../../store/store";
import SliderSound from "./Slider/SliderSound";
import { ISong, PlaylistType } from "../../../../types/interface";
import RndClose, { dragHandleStyles } from "../RndClose/RndClose";
import { showPopupType } from "../../Sidebar";
import { stat } from "fs";
type MixerProps = {
  showPopMixer: boolean;
  onShow: React.Dispatch<React.SetStateAction<showPopupType>>;
};
const playlistArr: { id: number; title: string; img: string }[] = [
  {
    id: 0,
    title: "lofi.co",
    img: IMAGE_SRC.logosmall,
  },
  {
    id: 1,
    title: "Spotify",
    img: Icons.spotify,
  },
];
const MixerPopup = React.forwardRef<HTMLDivElement, MixerProps>(
  ({ showPopMixer = false, onShow }: MixerProps, ref) => {
    const dispatch = useDispatch();
    const [indexPlaylist, setIndexPlaylist] = React.useState<number>(0);
    const [indexPlaylistType, setPlaylistType] = React.useState<number>(0);
    const [sliderSounds, setSliderSounds] = React.useState<any[]>(soundEffect);
    const isSpotify = useSelector((state: RootState) => state.audio.isSpotify);
    const playlist = useSelector((state: RootState) => state.audio.playlist);
    let currentIndexSong = useSelector(
      (state: RootState) => state.audio.currentIndexSong
    );
    let volumeValue = useSelector(
      (state: RootState) => state.audio.volumeValue
    );
    const handleGetPlaylist = async (playlist: PlaylistType, index: number) => {
      await dispatch(getPlaylist(playlist));
      setIndexPlaylist(index);
      dispatch(setPlay(true));
      dispatch(setCurrentIndexSong(0));
    };
    const handleChooseSpotify = (index: number, type: string) => {
      setPlaylistType(index);
      if (type === "Spotify") {
        dispatch(
          getPlaylist(
            PlaylistSong.find((item) => item.playlistId === "spotify")
          )
        );
        dispatch(setplaylistSpotify(true));
      } else {
        dispatch(setplaylistSpotify(false));
        dispatch(setCurrentIndexSong(0));
        dispatch(getPlaylist(PlaylistSong[indexPlaylist]));
      }
      dispatch(setPlay(true));
    };
    const handleClickSongPlay = (index: number, song: ISong) => {
      dispatch(setCurrentIndexSong(index));
      dispatch(setPlay(true));
    };
    const isDisabled = React.useMemo(() => {
      return playlist?.playlistId === "spotify";
    }, [playlist?.playlistId]);
    const disabledStyle = React.useMemo(() => {
      return {
        opacity: isDisabled ? 0.5 : 1,
        cursor: isDisabled ? "not-allowed" : "pointer",
      };
    }, [isDisabled]);
    const handleChangeVolume = (e: any, newValue: number | number[]) => {
      dispatch(setValueVolume(newValue as number));
    };
    const handleChangeSoundVolume = (
      e: Event,
      newValue: number | number[],
      index: number
    ) => {
      let newSliders = [...sliderSounds];
      newSliders[index] = { ...newSliders[index], levelSound: newValue };
      setSliderSounds(newSliders);
    };
    return (
      <Rnd
        style={{
          zIndex: 300,
        }}
        enableResizing={false}
        dragHandleClassName="dragHandlePdf"
      >
        <StyledMixerPopup
          style={{
            display: showPopMixer ? "" : "none",
          }}
          className="absolute flex flex-col  border-[hsla(0,0%,100%,.1)] popup-menu top-0 -left-[350px] bg-alphaBg px-3 rounded-lg"
        >
          <RndClose
            onClose={() =>
              onShow((prev) => {
                return {
                  ...prev,
                  showMixer: !prev.showMixer,
                };
              })
            }
          />
          <div className="w-80 has-scrollbar h-96">
            <div className="flex flex-col gap-y-3">
              <div className="flex gap-x-3">
                <div className="p-3 flex-1 bg-moodbg flex flex-col gap-y-4 border border-bordermood rounded-md">
                  <div className="flex justify-between">
                    <h3 className="text-sm font-medium text-secondary">
                      MUSIC
                    </h3>
                    <button className="custom-playlit">
                      <img
                        className="text-lg w-5 h-5"
                        src={Icons.customplaylist}
                        alt=""
                      />
                    </button>
                  </div>
                  <div className="grid grid-cols-3 gap-x-3">
                    {PlaylistSong.filter(
                      (item) => item.playlistId !== "spotify"
                    ).map((playlist, index) => {
                      return (
                        <button
                          disabled={isDisabled}
                          style={disabledStyle}
                          key={playlist.playlistId}
                          onClick={() => handleGetPlaylist(playlist, index)}
                          className={`flex playlist-item hover:text-white flex-col items-center gap-y-1 ${
                            indexPlaylist === index
                              ? "active"
                              : "text-secondary"
                          }`}
                        >
                          <span
                            className={`relative  playlist-icon  cursor-pointer bg-optionBg w-10 h-10 rounded-full flex justify-center items-center ${
                              isDisabled ? "is-disabled" : ""
                            }`}
                          >
                            {playlist.icon}
                          </span>
                          <span className="text-sm playlist-title select-none font-medium ">
                            {playlist.title}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div className="flex flex-col gap-y-3">
                  {playlistArr.map((item, index) => {
                    return (
                      <div
                        onClick={() => handleChooseSpotify(index, item.title)}
                        key={item.id}
                        className={`p-3 playlist-type cursor-pointer bg-moodbg border-bordermood border rounded-md flex items-center gap-x-3 ${
                          indexPlaylistType === index ? "active" : ""
                        }`}
                      >
                        <div className="relative">
                          <img
                            className="w-6 h-6 text-lg"
                            src={item.img}
                            alt=""
                          />
                        </div>
                        <span className="text-white select-none  text-sm font-medium">
                          {item.title}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
              {!isSpotify && (
                <div className="music-volume flex flex-col p-3 rounded-md bg-moodbg border border-moodbg">
                  <span className="text-sm font-semibold text-secondary">
                    MUSIC VOLUME
                  </span>
                  <div className="flex justify-betweengap-x-2 items-center">
                    <i className="bi mr-3 text-primary text-2xl leading-[0px] bi-volume-off-fill"></i>
                    <Slider
                      min={1}
                      value={volumeValue}
                      onChange={handleChangeVolume}
                      className="range-volume text-primary"
                      aria-label="Disabled slider"
                    />
                    <i className="bi ml-3 text-primary text-2xl leading-[0px] bi-volume-up"></i>
                  </div>
                </div>
              )}
              <div
                className={`py-3 px-2 h-40  has-scrollbar rounded-md bg-spotifyBg border border-moodbg  flex-col playlist-spotify hidden ${
                  isSpotify ? "active" : ""
                }`}
              >
                {isSpotify &&
                  playlist?.songs.map((song: ISong, index: number) => {
                    return (
                      <div
                        onClick={() => handleClickSongPlay(index, song)}
                        key={song.id}
                        className={`song-item select-none cursor-pointer hover:bg-primary border-b border-bordermood rounded-sm p-[6px] flex items-center justify-between ${
                          currentIndexSong === index ? "active" : ""
                        }`}
                      >
                        <div className="song-thumb rounded-sm  w-8 relative">
                          <img
                            className="rounded-sm"
                            src={song.thumbnail}
                            alt=""
                          />
                        </div>
                        <div className="song-name w-[150px] flex-shrink-0 text-white flex flex-col">
                          <span className="text-inherit text-sm font-medium">
                            {song.name}
                          </span>
                          <span className="text-xs text-textSecondary song-artist font-normal capitalize">
                            {song.artistName}
                          </span>
                        </div>
                        <div className="song-duration text-textSecondary text-xs">
                          {song?.duration}
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="p-3 flex flex-col gap-y-3 h-72 has-scrollbar rounded-md bg-moodbg border border-moodbg background-noises">
                <div className="flex items-center ">
                  <span className="text-primary text-base font-medium">
                    All SOUNDS
                  </span>
                </div>
                {sliderSounds?.map((sound, index) => {
                  return (
                    <SliderSound
                      key={sound.id}
                      type={sound.type}
                      volumeValue={sound.levelSound}
                      handleChange={(event, newValue) =>
                        handleChangeSoundVolume(event, newValue, index)
                      }
                      sourceSound={sound.source}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          <div className="relative flex justify-end items-center">
            <span className="dragHandlePdf" style={dragHandleStyles}></span>
          </div>
        </StyledMixerPopup>
      </Rnd>
    );
  }
);

export default React.memo(MixerPopup);
const StyledMixerPopup = styled.div`
  .playlist-item.active {
    .playlist-icon,
    .playlist-title {
      color: #f3a952;
    }
  }
  .playlist-type {
    transition: 0.4s all;
  }
  .playlist-type.active {
    border-color: #f3a952;
  }
  .playlist-type:not(.active):hover {
    border-color: #fff;
  }
  .song-item {
    &:hover .song-artist,
    &:hover .song-duration {
      color: #fff;
    }
    &.active {
      background-color: #f3a952;
    }
    &.active {
      .song-artist,
      .song-duration {
        color: #fff;
      }
    }
  }
  .playlist-spotify.active {
    display: flex;
  }
  .playlist-icon.is-disabled {
    cursor: not-allowed;
  }
`;
